import { render, staticRenderFns } from "./region_list.vue?vue&type=template&id=deb34a7c&scoped=true"
import script from "./region_list.vue?vue&type=script&lang=js"
export * from "./region_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb34a7c",
  null
  
)

export default component.exports